<template>
  <div id="confirm-order-page"
       v-if="showOrder && classList.length">
    <div class="container">
      <div class="page-title">
        <img class="inline-block"
             src="@/assets/img/logo-mass.png"
             width="106"
             alt="center of mass" />
        <span class="inline-block">确认订单信息</span>
      </div>
      <div class="border-wrapper"
           v-if="needAddress">
        <p class="text-dark-subject"
           style="margin-right: 10px">请选择收货地址</p>
        <span class="tips">为保证及时收到资料，建议您将收货地址设置为学校地址。</span>
        <div class="address-entry-add"
             v-if="addresses.length < 7">
          <button class="btn btn-text address-action"
                  @click="addAddresses({})">新增收货地址</button>
        </div>
        <slot v-for="(item, index) in addresses">
          <div @click="chosen(item.id)"
               :key="(index + 1)"
               v-if="Number(item.is_default) === 1 || index === 0 || showedAddresses"
               :class="'address-entry' + (Number(item.is_default) === 1?' default':'')">
            <div class="triangle"
                 v-if="Number(item.is_default) === 1">
              <i class="fa-zhixin fa-check"
                 style="color: #fff;"></i>
            </div>
            <div class="table-cell desp-ellipse pad-left-65"
                 style="width: 96px;">{{ item.name }}</div>
            <div class="table-cell"
                 style="width: 91px;">{{ item.mobile }}</div>
            <div class="table-cell "
                 style="padding-left: 80px;max-width: 250px">
              {{ item.province }}{{ item.city }}{{ item.district }} {{ item.address }}
            </div>
            <div class="table-cell text-right"
                 style="width: 100px">
              <span class="text-primary address-action"
                    @click="addAddresses(item)">修改</span>
              <span class="text-primary address-action"
                    @click="delAddresses(item.id)">删除</span>
            </div>
          </div>
        </slot>
        <div @click="showedAddresses = !showedAddresses"
             :class="'address-entry-more' + (showedAddresses ?' rotate': '')"
             v-if="addresses.length > 1">
          <span class="sublist-label">更多地址</span>
          <i class="fa fa-xiala"></i>
        </div>
      </div>
      <div class="border-wrapper"
           style="padding: 32px 0;border:0;">
        <p class="text-dark-subject"
           style="padding: 0 32px 0 8px;">课程清单</p>
        <div class="confirm-order"
             style="margin: 0;">
          <div class="live-list-container"
               style="font-size: 14px; display: block;">
            <slot v-for="(item, index) in classList">
              <confirmUnion v-if="item.union_id"
                            :item="item"
                            :key="index" />
              <confirmItem v-else
                           :item="item"
                           :isGroup="isGroup"
                           :key="index" />
            </slot>
          </div>
        </div>
      </div>
      <CouponRange v-if="goodsIds.length"
                   @getPrice="getOrderPrice"
                   :goodsid="goodsIds"
                   :playBackList="playBackList"
                   :unionId="unionId"
                   ref="CouponRange" />
      <div class="text-right primary-info"
           style="margin-top: 0">
        <div class="selected-address-block"
             style="background-color: transparent;">
          <div>合计金额：<span style="color:rgba(51,51,51,0.8);font-weight:500;">
              ¥{{Number(((classInfo.originalPrice)/100))}}
            </span></div>
          <div style="line-height: 1;margin-top: 16px;">活动优惠：<span style="color:rgba(51,51,51,0.8);font-weight:500;">
              -¥{{(classInfo.originalPrice - classInfo.cartPrice - couponPrice * 100)|priceFilter}}
            </span></div>
          <div style="line-height: 1;margin-top: 16px;">礼券优惠：<span style="color:rgba(51,51,51,0.8);font-weight:500;">
              -¥{{Number(couponPrice)}}
            </span></div>
        </div>
        <div class="selected-address-block">
          <div>实付金额：<span class="text-price active-price">¥{{(classInfo.cartPrice)|priceFilter}}</span></div>
          <slot v-if="needAddress && addresses.length">
            <div>邮寄地址：{{address.province}} {{address.city}} {{address.district}} {{address.address}}</div>
            <div>收件人：{{address.name}} {{address.mobile}}</div>
          </slot>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-lg btn-success btn-confirm-order"
                data-need="true"
                style="padding: 12px 48px;"
                @click="submitOrder">
          提交订单
        </button>
      </div>
      <div class="cannot-refund-bottom text-right">
        <i class="fa-zhixin text-warning fa-exclamation-circle"></i>所报课程中含有回放课程，回放课程不支持退款和换课！
      </div>
    </div>
    <Addresses ref="Addresses"
               :callback="handleAddresses" />
    <JoinUpNow ref="JoinUpNow"
               :classInfo="submitDate"></JoinUpNow>

  </div>
</template>

<script>
import $ from 'jquery'
import api from '@/api'
import confirmItem from './confirmItem'
import confirmUnion from './confirmUnion'
import Addresses from '@/components/Addresses'
import CouponRange from '@/components/CouponRange'
import JoinUpNow from '@/components/JoinUpNow'
import * as _ from 'underscore'
import { mapActions } from 'vuex'

export default {
  name: 'Confirm',
  data () {
    return {
      isGroup: false,
      priceInfo: {},
      showOrder: false,
      classList: [],
      materialsInfo: [],
      addressId: 0,
      addresses: [],
      needAddress: false,
      showedAddresses: false,
      needAddressMap: {},
      classInfo: {
        cartPrice: 0,
        originalPrice: 0
      },
      couponId: '',
      couponPrice: 0,
      groupState: true,
      goodsIds: [],
      cardInfo: {},
      goodsType: '',
      submitDate: {},
      zhuGeState: true
    }
  },
  mounted () {
    $('html,body').animate({ scrollTop: 0 }, 100)
    $('#cart-view .cart-view-wrap').hide()
  },
  provide () {
    return {
      provObj: {
        gooodId: []
      }
    }
  },
  filters: {
    priceFilter (value) {
      let sum = value
      sum = Math.max(Number((sum / 100).toFixed(2)), 0)
      return sum
    }
  },
  methods: {
    ...mapActions(['getCartCount']),
    handleData () {
      this.goodsIds = []
      _.each(this.classList, item => {
        if (!item.union_id) {
          this.goodsType = item.goods_type
          this.goodsIds.push(item.goods_id)
          this.needAddressMap[item.goods_id] = Number(item.need_address) === 1
        } else {
          _.each(item.union_cart_list, cla => {
            this.goodsType = cla.goods_type
            this.goodsIds.push(cla.goods_id)
            this.needAddressMap[cla.goods_id] = Number(cla.need_address) === 1
            if (this.materialsInfo && this.materialsInfo.length) {
              this.needAddressMap[cla.goods_id] = true
            }
          })
        }
      })
      // console.log('map', this.needAddressMap)
      this.needAddress = this.getNeedAddress(this.needAddressMap)
      if (this.needAddress) {
        this.getAddress()
      }
      this.$nextTick(() => {
        this.$refs.CouponRange.getCoupon()
      })
    },
    getGoodsInfo () {
      const goodsInfo = []
      _.each(this.classList, item => {
        if (!item.union_id) {
          goodsInfo.push({ goods_id: String(item.goods_id), goods_type: item.goods_type })
        } else {
          _.each(item.union_cart_list, cla => {
            goodsInfo.push({ goods_id: String(cla.goods_id), goods_type: cla.goods_type })
          })
        }
      })
      return goodsInfo
    },
    submitOrder () {
      this.submitDate.needAddress = this.needAddress
      this.submitDate.addressId = this.addressId
      this.submitDate.goodsType = this.goodsType
      this.submitDate.classList = this.classList
      this.submitDate.couponId = this.couponId
      this.submitDate.isCarConfirm = true
      this.submitDate.classId = '123'// 用不到
      this.submitDate.needAddressMap = this.needAddressMap
      this.$refs.JoinUpNow.invited_id = this.adminUserId || 0
      if (this.goodsType === 2) {
        this.$refs.JoinUpNow.createOrder()
      } else {
        this.$refs.JoinUpNow.showDialogComfirm(true)
        this.$refs.JoinUpNow.getCacheOfflineOrder()
        this.$refs.JoinUpNow.carPlayBackList = this.playBackList // 回放赋值
      }
    },
    getNeedAddress (map = {}) {
      for (const key in map) {
        if (map[key]) {
          return true
        }
      }
      return false
    },
    getAddress () {
      api.getAddress().then(res => {
        if (res.data.code === 1) {
          this.addresses = res.data.data.addresses
          this.sortAddresses()
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    handleAddresses () {
      if (this.handle) {
        this.addressId = ''
      }
      this.getAddress()
    },
    setDefault (id) {
      api.setDefault({ id }).then(res => {
        if (res.data.code === 1) {
          this.addresses.forEach((addr) => {
            addr.is_default = Number(addr.id) === Number(id) ? 1 : 0
          })
          this.sortAddresses()
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    sortAddresses () {
      this.addresses.sort(function (a, b) {
        return Number(b.is_default) - Number(a.is_default)
      })
      if (this.addresses.length) {
        const address = this.addresses.filter(item => {
          return Number(item.is_default) === 1
        })
        this.addressId = address.length ? address[0].id : ''
      }
    },
    chosen (id) {
      if (id === this.addressId) {
        return false
      }
      this.setDefault(id)
      this.showedAddresses = false
    },
    addAddresses (item) {
      this.handle = false
      this.$refs.Addresses.handle = JSON.stringify(item) !== '{}'
      this.$refs.Addresses.showDialog($.extend(true, {}, item))
    },
    delAddresses (id) {
      this.handle = true
      this.$refs.Addresses.deleteAddress(id)
    },
    // 获取优惠券金额
    getOrderPrice () {
      this.couponId = this.$refs.CouponRange.pickCoupon.pickId
      this.initCalCartPrice()
    },
    initCalCartPrice () {
      const goodsInfo = this.getGoodsInfo()
      goodsInfo.forEach(item => {
        if (!this.playBackList) {
          item.offline_replay = 0
        } else {
          const checkedId = this.playBackList.split(',')
          if (checkedId.indexOf(item.goods_id) > -1) {
            item.offline_replay = 1
          } else {
            item.offline_replay = 0
          }
        }
        if (this.unionId) {
          item.activity_id = this.unionId
          item.activity_type = 2
        }
      })
      api
        .calCartPrice({
          compute: true,
          coupon_id: this.couponId,
          goods_items: goodsInfo
        })
        .then(res => {
          if (res.data.code === 1) {
            const item = res.data.data
            this.classInfo.cartPrice = Number(item.cart_price)
            this.classInfo.originalPrice = Number(item.original_price)
            this.updatePrice(item.goods_discounts)
            if (this.zhuGeState) {
              this.zhuGeEventTrack(this.zhugeEvents.VISIT_ORDER_CONFIRMING_PAGE, [
                this.needAddress,
                !!this.couponId,
                this.unionId ? '联报' : '购课单',
                Number((this.classInfo.originalPrice / 100).toFixed(2)),
                Number(((this.classInfo.originalPrice - this.classInfo.cartPrice - this.couponPrice * 100) / 100).toFixed(2)),
                this.goodsType === 2 ? '直播课' : '面授课'
              ])
            }
            this.zhuGeState = false
          }
          this.loading = false
        })
    },
    handleMaterialPrice (price, obj, discountObj) {
      let handlePrice = price
      for (let i = 0; i < discountObj.length; i++) {
        if (obj.material_goods_id === discountObj[i].goods_id) {
          // cla.needPrice = item.real_price + dataListElement[i].real_price
          handlePrice += discountObj[i].real_price
        }
      }
      return handlePrice
    },
    updatePrice (dataListElement) {
      let realPrice = 0
      let originalPrice = 0
      _.each(dataListElement, item => {
        if (item.coupon_id > 0) {
          originalPrice += item.original_price
          realPrice += item.real_price
        }
        _.each(this.classList, (cla) => {
          if (!cla.union_id) {
            if (Number(item.goods_id) === Number(cla.goods_id)) {
              cla.needPrice = this.handleMaterialPrice(item.real_price, cla, dataListElement)
            }
          } else {
            _.each(cla.union_cart_list, union => {
              if (Number(item.goods_id) === Number(union.goods_id)) {
                union.needPrice = this.handleMaterialPrice(item.real_price, union, dataListElement)
              }
            })
          }
        })
      })
      this.couponPrice = Math.max(Number((originalPrice / 100 - realPrice / 100).toFixed(2)), 0)
    }

  },
  components: { confirmItem, confirmUnion, Addresses, CouponRange, JoinUpNow },
  watch: {
    'classList.length' () {
      this.handleData()
    }
  },
  computed: {
    address () {
      return this.addresses.filter((item) => {
        return Number(item.is_default) === 1
      })[0] || {}
    }
  },
  beforeDestroy () {
    $('#cart-view .fixed-bar').hide()
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
@import "@/assets/scss/mixins/base.scss";
@import "@/assets/scss/partials/_zhixin.scss";
@import "@/assets/scss/partials/_class_register.scss";

#confirm-order-page {
  z-index: 100;
  background: #fff;
  padding-bottom: 0;

  .inline-block {
    margin-right: 10px;
  }

  .text-warning {
    color: #ffc954;
  }
}
</style>
